import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { SiGeeksforgeeks ,
    SiCodingninjas,
    SiLeetcode,
    SiCodechef,
} from "react-icons/si";
function CodingPlatform  ()  {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

        <Col xs={4} md={2} className="tech-icons">
            <a href='https://www.geeksforgeeks.org/user/shubhanshutiwari04/'>
                <SiGeeksforgeeks  />
            </a>
            
        </Col>

        <Col xs={4} md={2} className="tech-icons">
            <a href='https://www.naukri.com/code360/profile/its_shubh'>
                <SiCodingninjas/>
            </a>
            
        </Col>

        <Col xs={4} md={2} className="tech-icons">
            <a href='https://leetcode.com/u/Shubhanshu9450/'>
                <SiLeetcode/>
            </a>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
            <a href='https://www.codechef.com/users/shubhanshu_18'>
                <SiCodechef/>
            </a>
        </Col>

        
    </Row>
    
  )
}

export default CodingPlatform